import type { FunctionComponent } from 'react';
import type React from 'react';

import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import {
  NavigationLinks,
  type ClickTracking,
} from '@/domains/productDiscovery/Listings/components/NavigationLinks/NavigationLinks';

import type { SmartLink } from '../../../../MassLanding.model';

export interface TopNavigationLinksProps {
  className?: string;
  links: SmartLink[];
}

export const TopNavigationLinks: FunctionComponent<TopNavigationLinksProps> = ({
  className,
  links,
}) => {
  const addTracking = (
    _: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    tracking: ClickTracking,
  ) => {
    Gtm.push({
      event: 'interaction_click_on_a_masslanding_tag',
      e_category: 'navigation',
      e_action: 'Click on a Masslanding tag',
      event_trigger: 'category_listing',
      amp_event_name: 'Click on a Masslanding tag',
      item_position: tracking.position,
      item_name: tracking.label,
      redirection_link: tracking.url,
      interaction_hit: 'False',
    });
  };

  return (
    <NavigationLinks
      className={className}
      links={links}
      onItemClick={addTracking}
    />
  );
};

TopNavigationLinks.displayName = 'TopNavigationLinks';
